import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faCalendar, faDollarSign } from '@fortawesome/pro-regular-svg-icons';
import getTranslation from '../../../../strings/i18n';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import formatDisplayDate from 'syf-js-utilities/formats/formatDisplayDate';
import { StyledBorder, StyledFlex } from '../../../../styles/common';
import { validateAmount } from '../../../../helpers/utils/amount-utils';
import useDeviceWidth from '../../../../hooks/use-device-width';
import { StyledTitle } from '../../../../styles/text';
import CompleteIllustration from '../../../../ui/common/illustrations/cancel-payment/complete';
import InfoHeader from '../../../../ui/common/info-header';
import TransactionDetail from '../../../../ui/common/transaction-detail';
var CancelPaymentComplete = function (_a) {
    var _b;
    var currentTransaction = _a.currentTransaction;
    var t = getTranslation().t;
    var isMobile = useDeviceWidth();
    var type = currentTransaction.type;
    var displayedTransactionAmount = validateAmount(currentTransaction.amount);
    var extraInfoArray = [
        {
            detail: displayedTransactionAmount,
            heading: t('activityDetails.amountLabel'),
            icon: faDollarSign,
            title: 'amountLabel'
        },
        {
            detail: formatDisplayDate(new Date((_b = currentTransaction.paymentInfo) === null || _b === void 0 ? void 0 : _b.scheduledDate)),
            heading: t('activityDetails.cancelPayment.scheduledForLabel'),
            icon: faCalendar,
            title: 'scheduled for'
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx(InfoHeader, { description: "PAYMENT", iconType: type, status: "CANCELED" }), _jsx(Inset, { horizontal: "xlarge", children: _jsxs(StyledFlex, { justifyContent: "center", direction: "column", alignItems: "center", children: [_jsx(CompleteIllustration, {}), _jsx(Stack, { size: "large" }), _jsx(Inset, { vertical: isMobile ? 'large' : 'xlarge', children: _jsx(StyledTitle, { align: "center", lineHeight: "1.6", size: "medium", children: t('activityDetails.cancelPayment.canceledCompleteHeader') }) })] }) }), _jsxs(Inset, { vertical: "xxlarge", children: [_jsx(StyledTitle, { as: "h4", size: "medium", weight: "light", children: t('activityDetails.detailsLabel') }), _jsx(Inset, { horizontal: "medium", children: _jsx(StyledBorder, {}) }), _jsx("dl", { children: extraInfoArray.map(function (label) { return (_jsx(TransactionDetail, { detail: label.detail, heading: label.heading, icon: label.icon, title: label.title, currentFlow: "cancelPayment" }, label.title)); }) })] })] }));
};
export default CancelPaymentComplete;
//# sourceMappingURL=index.js.map